import type { FileExplorerIconSize } from '../../logic/core/useFileManagerSettings';

// Tuned for an inline row icon (DetailsTableView), not a grid tile.
export const ICON_PIXEL_SIZES: Record<FileExplorerIconSize, number> = {
  small: 20,
  medium: 24,
  large: 28,
};

export const FONT_SIZES: Record<FileExplorerIconSize, string> = {
  small: '0.8125rem',
  medium: '0.875rem',
  large: '1rem',
};
